<div
  *ngIf="sub_category_collection.length"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="sub_category_collection"
    class="sp-width__full">
    <ng-container matColumnDef="sub_category_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_SUBCATEGORY.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let subcategory">
        <app-shared-id
          [content]="subcategory.sub_category_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_SUBCATEGORY.NAME_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let subcategory">
        <span class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ subcategory.name }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="ecommerce_default">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_SUBCATEGORY.ECOMMERCE_DEFAULT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let subcategory">
        <span class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ subcategory.ecommerce_default ? ('GENERAL.YES_LABEL' | translate) : ('GENERAL.NO_LABEL' | translate) }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'PRODUCT_SUBCATEGORY.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let subcategory">
        <div class="sp-row__align">
          <button
            (click)="$event.stopPropagation()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [mat-menu-trigger-for]="subcategories_actions_menu">
            <mat-icon> more_horiz </mat-icon>
          </button>

          <mat-menu #subcategories_actions_menu="matMenu">
            <button
              (click)="onEditClick(subcategory); $event.stopPropagation()"
              class="sp-padding__vert"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> edit </mat-icon>
              <span> {{ 'PRODUCT_SUBCATEGORY.EDIT_CTA' | translate }} </span>
            </button>

            <button
              (click)="onDeleteClick(subcategory); $event.stopPropagation()"
              class="sp-padding__vert"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__warn"> delete </mat-icon>
              <span> {{ 'PRODUCT_SUBCATEGORY.DELETE_CTA' | translate }} </span>
            </button>
          </mat-menu>
        </div>
      </td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      class="sp-cursor__pointer"
      *matRowDef="let row; columns: displayed_columns"></tr>
  </table>
</div>
